import { errInfo } from './err-info';
export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["error"] = 0] = "error";
    LogLevel[LogLevel["warning"] = 1] = "warning";
    LogLevel[LogLevel["info"] = 2] = "info";
    LogLevel[LogLevel["debug"] = 3] = "debug";
})(LogLevel || (LogLevel = {}));
export class PromiseSyncer {
    constructor(logger) {
        this.logger = logger;
        this.promise = Promise.resolve();
        this.errors = [];
        this.syncCounter = 0;
    }
    sync(logPrefix, func) {
        const syncId = ++this.syncCounter;
        this.logger.debug(`${logPrefix}, SYNC syncId = ${syncId}, IN `);
        this.promise = this.promise.then(async () => {
            this.logger.debug(`${logPrefix}, SYNC syncId = ${syncId}, START `);
            await func();
            this.logger.debug(`${logPrefix}, SYNC syncId = ${syncId}, END `);
        }).catch((err) => {
            const [errMsg, errStack] = errInfo(err);
            this.logger.error(`${logPrefix}, SYNC syncId = ${syncId}, ERROR:\n${errMsg}`, undefined, errStack);
            this.errors.push(err);
        });
        // this.logger.debug(`${logPrefix}, SYNC syncId = ${syncId}, OUT`);
    }
    resetErrors() {
        const res = this.errors;
        this.errors = [];
        return res;
    }
}
//# sourceMappingURL=syncer.js.map